import { CONTROLLER, METHOD } from 'common/config/endpoint.config';
import { ApiMethods } from 'common/enums/api-methods.enum';
import { ConfigurationTypes, WhatsNewLinkType } from '../enums/configuration.enum';
import { ApiConfig } from 'common/models/api-service/api-config.model';
import {
    ConfigurationListRequest,
    ConfigurationReorderUpdateList,
    ConfigurationSaveLinkRequest,
    ConfigurationSaveRequest,
    ConfigurationWhatsNewDeleteRequest,
    DeleteConfigRequestType,
    DeleteConfigurationRequest,
    DeleteVideoLinkPayload,
    IndicatorSourceDTO,
    TrendingDataSaveRequest,
    VideoDetailsPayload,
    WhatsNewIndicatorSaveRequest
} from '../models/configuration.model';
import { PagedRequest } from 'common/models/data/pagedRequest.model';

const configurationApiConfig = {
    getUploadFileLog: (payload: any): ApiConfig =>
        new ApiConfig(`FileUpload/getUploadList`, 'POST', '', payload),
    getConfigurationData: (payload: ConfigurationListRequest): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.CONFIGURE}`,
            ApiMethods.POST,
            '',
            payload
        ),
    deleteConfigurationData: (payload: DeleteConfigurationRequest): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.DELETE}`,
            ApiMethods.POST,
            '',
            payload
        ),
    getTrendingData: (): ApiConfig =>
        new ApiConfig(`${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.TRENDING_DATA}`),
    reorderConfigurationData: (payload: ConfigurationReorderUpdateList[]): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.REORDER}`,
            ApiMethods.POST,
            '',
            payload
        ),
    reorderTrendingData: (payload: ConfigurationReorderUpdateList[]): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.REORDER_TRENDING_DATA}`,
            ApiMethods.POST,
            '',
            payload
        ),

    deleteTrendingData: (payload: DeleteConfigRequestType): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.DELETE_TRENDING_DATA}`,
            ApiMethods.POST,
            '',
            payload
        ),
    saveConfiguration: (payload: ConfigurationSaveRequest<ConfigurationTypes>): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.SAVE_CONFIGURATION}`,
            ApiMethods.POST,
            '',
            payload
        ),
    saveTrendingConfiguration: (payload: TrendingDataSaveRequest): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.SAVE_TRENDING_CONFIGURATION}`,
            ApiMethods.POST,
            '',
            payload
        ),
    uploadFile: (formData: FormData, header: any, additionalConfig: any): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.SAVE_WHATS_NEW_VIDEO_OR_IMAGE}`,
            ApiMethods.POST,
            '',
            formData,
            '',
            header,
            additionalConfig
        ),
    getWhatsNewData: (): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.WHATS_NEW}`,
            ApiMethods.GET,
            ''
        ),
    deleteWhatsNewConfigurationData: (payload: ConfigurationWhatsNewDeleteRequest): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.DELETE_WHATS_NEW}`,
            ApiMethods.POST,
            '',
            payload
        ),
    saveWhatsNewIndicator: (payload: WhatsNewIndicatorSaveRequest<WhatsNewLinkType>): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.SAVE_WHATS_NEW}`,
            ApiMethods.POST,
            '',
            payload
        ),
    reorderWhatsNewConfiguration: (payload: ConfigurationReorderUpdateList[]): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.WHATS_NEW_REORDER}`,
            ApiMethods.POST,
            '',
            payload
        ),
    saveWhatsNewLink: (payload: ConfigurationSaveLinkRequest): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.SAVE_WHATS_NEW_LINK}`,
            ApiMethods.POST,
            '',
            payload
        ),
    getCategoriesUrl: (pagedRequest: PagedRequest): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.GET_CATEGORIES}`,
            ApiMethods.POST,
            '',
            pagedRequest
        ),
    getEntitiesByCategoryIdUrl: (categoryId: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.ENTITIES_BY_CATEGORY_ID}/${categoryId}`,
            ApiMethods.GET
        ),
    getEntitiesByHierarchyIdUrl: (hierarchyId: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.ENTITIES_BY_HIERARCHY_ID}/${hierarchyId}`,
            ApiMethods.GET
        ),
    getConfigBlobSasUrl: (payload: {
        fileName: string;
        whatsNewTypes: WhatsNewLinkType;
    }): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.CONFIGURATION}/${METHOD.CONFIGURATION.BLOB_SAS_URL}`,
            ApiMethods.POST,
            '',
            payload
        ),
    fetchIndicatorSources: (payload: PagedRequest): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.SOURCE}/${METHOD.SOURCE.GET_INDICATOR_SOURCES}`,
            ApiMethods.POST,
            '',
            payload
        ),
    addIndicatorSource: (payload: IndicatorSourceDTO): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.SOURCE}/${METHOD.SOURCE.ADD_INDICATOR_SOURCE}`,
            ApiMethods.POST,
            '',
            payload
        ),
    updateIndicatorSource: (payload: IndicatorSourceDTO): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.SOURCE}/${METHOD.SOURCE.UPDATE_INDICATOR_SOURCE}`,
            ApiMethods.POST,
            '',
            payload
        ),

    deleteIndicatorSource: (payload: IndicatorSourceDTO): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.SOURCE}/${METHOD.SOURCE.DELETE_INDICATOR_SOURCE}/${payload.sourceId}`,
            ApiMethods.POST,
            ''
        ),
    saveVideoLink: (payload: VideoDetailsPayload): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.VIDEO_DETAILS}/${METHOD.VIDEO_DETAILS.SAVE_VIDEO_DETAILS}`,
            ApiMethods.POST,
            '',
            payload
        ),
    updateVideoLink: (payload: VideoDetailsPayload): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.VIDEO_DETAILS}/${METHOD.VIDEO_DETAILS.UPDATE_VIDEO_DETAILS}`,
            ApiMethods.POST,
            '',
            payload
        ),
    deleteVideoLink: (payload: DeleteVideoLinkPayload): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.VIDEO_DETAILS}/${METHOD.VIDEO_DETAILS.DELETE_VIDEO_DETAILS}`,
            ApiMethods.POST,
            '',
            payload
        ),
    getConfigurationVideoLink: (): ApiConfig =>
        new ApiConfig(`${CONTROLLER.VIDEO_DETAILS}/${METHOD.VIDEO_DETAILS.VIDEO_DETAILS}`),
    getConfigurationVideoTypes: (): ApiConfig =>
        new ApiConfig(`${CONTROLLER.VIDEO_DETAILS}/${METHOD.VIDEO_DETAILS.VIDEO_TYPES}`)
};

export default configurationApiConfig;
